
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"currentColor","cx":"25","cy":"25","r":"25"}}),_c('path',{attrs:{"stroke":"#FFF","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round","d":"M17.303 25.616l5.23 7.121 12.164-15.474"}})])])
          )
        }
      }
    